// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"715":"d5e326a1361dccc4e3a4","828":"01f2f5bfd4cc98888527"}[chunkId] + ".js";
};